import { memo } from 'react';

const AuthHeroPanel = memo(({ src, alt = 'Dine Savvy' }) => (
  <div className="relative hidden min-h-[200px] flex-1 lg:block">
    <img src={src} alt={alt} className="absolute inset-0 size-full object-cover" />
  </div>
));

AuthHeroPanel.displayName = 'AuthHeroPanel';

export default AuthHeroPanel;
